import { Routes, Route } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { Layout } from './components/Layout'
import { LoadingSpinner } from './components/ui/LoadingSpinner'
import { NicknameModal } from './components/onboarding/NicknameModal'
import { useUserProfile } from './hooks/useUserProfile'
import { Dashboard } from './pages/Dashboard'
import { Games } from './pages/Games'
import { GameDetail } from './pages/GameDetail'
import { Players } from './pages/Players'
import { PlayerProfile } from './pages/PlayerProfile'
import { Statistics } from './pages/Statistics'
import { Admin } from './pages/Admin'
import { SuperAdmin } from './pages/SuperAdmin'
import { Profile } from './pages/Profile'
import { Login } from './pages/Login'
import { CreateGame } from './pages/CreateGame'
import { JoinTeam } from './pages/JoinTeam'

function App() {
  const { isLoading, isAuthenticated } = useAuth0()
  const { profile, isLoading: profileLoading, needsOnboarding, refetch } = useUserProfile()

  if (isLoading || (isAuthenticated && profileLoading)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Login />
  }

  return (
    <>
      {needsOnboarding && (
        <NicknameModal 
          onComplete={() => refetch()} 
          currentNickname={profile?.nickname}
        />
      )}
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/games" element={<Games />} />
          <Route path="/games/:id" element={<GameDetail />} />
          <Route path="/games/new" element={<CreateGame />} />
          <Route path="/players" element={<Players />} />
          <Route path="/players/:id" element={<PlayerProfile />} />
          <Route path="/statistics" element={<Statistics />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/superadmin" element={<SuperAdmin />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/join" element={<JoinTeam />} />
        </Routes>
      </Layout>
    </>
  )
}

export default App
